import { useTheme } from "@mui/material";
import DSDrawer from "views/system-design/DSDrawer";
import DSBox from "views/system-design/DSBox";
import { APPBAR_HEIGHT } from "consts/layout";
import { useIsMobile } from "../../hooks/useIsMobile";

interface DetailDrawerProps {
  open: boolean;
  onClose: () => void;
  // Re-mounts the content when it changes (e.g. the selected item id).
  contentKey?: string;
  children: React.ReactNode;
}

/**
 * Right-hand detail drawer shared by the Klydoscope tabs: non-modal on
 * desktop (the list behind stays clickable) and full-screen on mobile.
 * Starts below the fixed app navbar so the title is not tucked under it.
 */
export default function DetailDrawer({
  open,
  onClose,
  contentKey,
  children,
}: DetailDrawerProps) {
  const isMobile = useIsMobile();
  const { spacing } = useTheme();
  const headerOffset = spacing(APPBAR_HEIGHT);

  return (
    <DSDrawer
      open={open}
      anchor="right"
      onClose={onClose}
      hideBackdrop={!isMobile}
      disableEnforceFocus
      disableAutoFocus
      disableScrollLock={!isMobile}
      ModalProps={{
        sx: { pointerEvents: isMobile ? "auto" : "none" },
      }}
      PaperProps={{
        sx: {
          width: isMobile ? "100vw" : 480,
          maxWidth: "100vw",
          top: headerOffset,
          height: `calc(100% - ${headerOffset})`,
          pointerEvents: "auto",
          boxShadow: 8,
        },
      }}
    >
      {children && (
        <DSBox
          key={contentKey}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden",
          }}
        >
          {children}
        </DSBox>
      )}
    </DSDrawer>
  );
}
